import "../scss/index.scss";
import OsmMap from './components/OsmMap.js';
import SectorMap from './components/SectorMap.js';
import SectorMapSlider from './components/SectorMapSlider.js';
// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

//photoswipe
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';

$(document).ready(function () {


    new SectorMap();
    new SectorMapSlider();

    // Do stuff here
    var isScrolled = false;
    var isScrolledClass = false;
    var scroll = $(window).scrollTop();
    setScrolledClass(scroll);

    $(window).scroll(function (event) {
        var scroll = $(window).scrollTop();
        setScrolledClass(scroll);
    });

    function setScrolledClass(scroll) {
        if (scroll > 30) {
            isScrolled = true;
        } else {
            isScrolled = false;
        }

        if (isScrolled === true && isScrolledClass === false) {
            $('body').addClass('scrolled');
            //$('body.home #nav-main').removeClass('navbar-dark').addClass('navbar-light');
            isScrolledClass = true;
        } else if (isScrolled === false && isScrolledClass === true) {
            $('body').removeClass('scrolled');
            //$('body.home #nav-main').removeClass('navbar-light').addClass('navbar-dark');
            isScrolledClass = false;
        }
    }


    if ($(".hd__realty-teaser__image-slider").length) {

        var hdRealtyTeaserImagesSlider = new Swiper(".hd__realty-teaser__image-slider", {
            grabCursor: true,
            slidePerView: 1,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }


    if ($(".home__letter-loc__slider").length) {
        const lettreLocataire = new Swiper(".home__letter-loc__slider", {
            grabCursor: true,
            effect: "creative",
            navigation: {
                nextEl: ".home__letter-loc__slider-wrapper .swiper-button-next",
                prevEl: ".home__letter-loc__slider-wrapper .swiper-button-prev",
            },
            creativeEffect: {
                limitProgress: 3,
                shadowPerProgress: true,
                prev: {
                    shadow: true,
                    translate: ["-80%", 0, -500],
                    opacity: 1
                },
                next: {
                    shadow: true,
                    translate: ["80%", 0, -500],
                    opacity: 1
                },
            },
        });
    }

    if ($(".hd__section__accordion").length) {
        var isEditorActive = $('body.elementor-editor-active').length;
        if (isEditorActive === 0) {
            window.addEventListener('elementor/frontend/init', () => {
                function sectionAccordionResize() {
                    var deviceMode = $('body').attr('data-elementor-device-mode');
                    var deviceModes = ['mobile'];

                    if (deviceModes.indexOf(deviceMode) >= 0) {
                        $(".hd__section__accordion .e-n-accordion .e-n-accordion-item").removeAttr('open').attr('close', true);
                    } else {
                        $(".hd__section__accordion .e-n-accordion .e-n-accordion-item").removeAttr('close').attr('open', true);
                    }
                }


                sectionAccordionResize();
                window.onresize = sectionAccordionResize;
            });
        }
    }

//    // Function to expand all accordion panes
//    function expandAll() {
//        document.querySelectorAll(".e-n-accordion-item").forEach(function (accordionItem) {
//            accordionItem.open = true;
//        });
//    }
//
//    // Function to collapse all accordion panes
//    function collapseAll() {
//        document.querySelectorAll(".e-n-accordion-item").forEach(function (accordionItem) {
//            accordionItem.open = false;
//        });
//    }

    if($('.hd-customer__rental-step__slider').length) {
        
            var hdCustomerRentalStepCurrent = 0;
            
            if ($('.hd-customer__rental-step__slider .swiper-slide.current').length) {
                hdCustomerRentalStepCurrent = $('.hd-customer__rental-step__slider .swiper-slide.current').attr('data-slide-index');
            }

            var hdCustomerRentalStepSlider = new Swiper(".hd-customer__rental-step__slider", {
                grabCursor: true,
                slidesPerView: "auto",
                initialSlide: hdCustomerRentalStepCurrent,
                spaceBetween: 10,
                navigation: {
                    nextEl: ".hd-customer__rental-step__slider-navigation .swiper-button-next",
                    prevEl: ".hd-customer__rental-step__slider-navigation .swiper-button-prev",
                },
                scrollbar: {
                    el: '.hd-customer__rental-step__slider-navigation .swiper-scrollbar',
                    draggable: true,
                },
            });            
        }

    if ($(".hd__realty__image-slider").length) {

        /**
         * window resize basé sur le class device (breakpoint) elementor
         * on doit attendre que celle-ci soit initialisée
         */
        window.addEventListener('elementor/frontend/init', () => {

            const lightbox = new PhotoSwipeLightbox({
                    gallery: '.hd__realty__image-slider > .swiper-wrapper',
                    children: 'a',
                    pswpModule: () => PhotoSwipe
                  });

            const realtyThumbSlider = new Swiper(".hd__realty__thumb-slider", {
                spaceBetween: 20,
                slidesPerView: 'auto',
                freeMode: true,
                watchSlidesProgress: true,
                slideToClickedSlide: true,
                direction: 'vertical'
            });
            const realtyImageSlider = new Swiper(".hd__realty__image-slider", {
                spaceBetween: 0,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },

                thumbs: {
                    swiper: realtyThumbSlider,
                },

                on: {
                    afterInit: function () {
                       realtyImageSliderResize();
                       lightbox.init(); 
                    },
                },
            });
             
            $('.swiper-button-zoom').on('click', function() {
                $('.hd__realty__image-slider .swiper-slide-active').click();
                
                //var activeIndex = realtyImageSlider.activeIndex;
                //lightbox.loadAndOpen(activeIndex);
            });

            function realtyImageSliderResize() {
                var deviceMode = $('body').attr('data-elementor-device-mode');
                var deviceModes = ['desktop', 'widescreen', 'laptop', 'tablet'];

                if (deviceModes.indexOf(deviceMode) >= 0) {
                    if (realtyThumbSlider.params.direction = 'horizontal') {
                        realtyThumbSlider.changeDirection('vertical');
                    }

                    var $height = $('.hd__realty__thumb-slider .swiper-slide img').height();
                    $('.hd__realty__thumb-slider .swiper-slide').height($height);

                    var $height = $('.hd__realty__image-slider .swiper-slide img').height();
                    $('.hd__realty__slider-wrapper').height($height);

                } else {
                    $('.hd__realty__slider-wrapper').height('auto');

                    if (realtyThumbSlider.params.direction = 'vertical') {
                        realtyThumbSlider.changeDirection('horizontal');
                    }
                }
            }

            window.onresize = realtyImageSliderResize;
        });

    }
}); // jQuery End

function addEvent(event, selector, callback, context) {
    document.addEventListener(event, e => {
        if ( e.target.closest(selector) ) {
            callback(e);
        }
    });
}
addEvent('click', '.cmplz-show-banner', function(){
    document.querySelectorAll('.cmplz-manage-consent').forEach(obj => {
        obj.click();
    });
});
